var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.modalType,{tag:"component",attrs:{"visible":_vm.visible,"size":"lg","title":_vm.modalProps.title},on:{"hide":function($event){return _vm.hideModal()}}},[_c(_vm.component,_vm._b({tag:"component"},'component',_vm.modalProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }